<template>
  <div
    class="board"
    ref="board"
  >
    <div class="sks"><span @click="gos">
        ＜ </span>
      三棵树专区
    </div>
    <van-swipe :autoplay="3000">
      <van-swipe-item
        v-for="(image, index) in images"
        :key="index"
      >
        <!-- <img :src="image" /> -->
        <img
          src="../../assets/sks/l1.jpg"
          alt=""
        >
      </van-swipe-item>

    </van-swipe>
    <div class="pad"></div>
    <div
      class="sp"
      style=""
    >
      <iframe
        frameborder="0"
        src="https://www.huokongjian.net/index/index/newslist.html"
        width="100%"
        height="100%"
        scrolling="no"
      ></iframe> 
    </div>
    <div class="flp">
      <div class="fenl clearfix">
        <p>· 产品分类 ·</p>
        <div
          class="fenl_1"
          @click="toList(1137)"
        >
          <img src="../../assets/sks/n1.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">马上住分销入口</div>
        </div>
        <div
          class="fenl_1"
          @click="toList(1138)"
        >
          <img src="../../assets/sks/n2.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">乳胶漆</div>
        </div>
        <div
          class="fenl_1"
          @click="toList(1923)"
        >
          <img src="../../assets/sks/n3.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">胶黏剂(胶水)</div>
        </div>
         <div
          class="fenl_1"
          @click="toList(2039)"
        >
          <img src="../../assets/sks/n10.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">底漆</div>
        </div>
        <div
          class="fenl_1"
          @click="toList(1140)"
        >
          <img src="../../assets/sks/n4.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">工程涂料</div>
        </div>
        <div
          class="fenl_1"
          @click="toList(1141)"
        >
          <img src="../../assets/sks/n5.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">木器漆</div>
        </div>
        <div
          class="fenl_1"
          @click="toList(1142)"
        >
          <img src="../../assets/sks/n6.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">美缝剂</div>
        </div>
        <div
          class="fenl_1"
          @click="toList(1143)"
        >
          <img src="../../assets/sks/n7.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">基辅材</div>
        </div>
        <div
          class="fenl_1"
          @click="toList(1144)"
        >
          <img src="../../assets/sks/n8.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">防水卷材</div>
        </div>
          
        <div
          class="fenl_1"
          @click="toList(1145)"
        >
          <img src="../../assets/sks/n9.png" />
          <!-- <div>{{ item }}</div> -->
          <div class="">活动专区</div>
        </div>
      </div>
    </div>

    <div class="wgd">
      <!-- <img
        class="qx"
        src="../../../assets/sks/sksq.png"
        alt=""
      /> -->
      <div class="gd"></div>
    </div>

    <div>

      <img
        class="ak1"
        src="../../assets/sks/h1.jpg"
        alt=""
      />
      <img
        class="ak1"
        src="../../assets/sks/h2.jpg"
        alt=""
      />
      <img
        class="ak1"
        src="../../assets/sks/sks11.jpg"
        alt=""
      />
      <div class="wgdb jia">
        <img
          @click="go(9)"
          class="wen1"
          src="../../assets/sks/sksw2.png"
          alt=""
        />
      </div>
      <div class="cp1">
        <div class="top clearfix">
          <div
            class="one"
            @click="go(1)"
          >
            <img
              src="../../assets/sks/01.png"
              alt=""
            />
          </div>
          <div
            class="one"
            @click="go(2)"
          >
            <img
              src="../../assets/sks/02.png"
              alt=""
            />
          </div>
          <div
            class="one"
            @click="go(3)"
          >
            <img
              src="../../assets/sks/03.png"
              alt=""
            />
          </div>
          <div
            class="one"
            @click="go(4)"
          >
            <img
              src="../../assets/sks/04.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <img
      class="ak1"
      src="../../assets/sks/sks22.jpg"
      alt=""
    />
    <img
      class="ak1"
      src="../../assets/sks/sks11.jpg"
      alt=""
    />
    <!-- <div class="wgdb jia">
      <img
        class="wen1"
        src="../../assets/sks/sksw3.png"
        alt=""
      />
    </div> -->
    <div class="xgd"></div>

    <div class="fl2p">
      <div
        class="board_imglist"
        v-if="navSwitch == 1 && productList.length"
      >
        <div
          class="board_img"
          v-for="(item, index) in productList"
          @click="enterDetail(item)"
          :key="index"
        >
          <div>
            <img :src="URL + item.pic_url" />
          </div>
          <div class="title">
            <span
              v-if="false"
              class="sp1"
            >杰伦</span>
            <span class="sp2">{{ item.title }}</span>
          </div>
          <div v-if="login == 1">
            <span>￥{{ item.price_member }}</span>
            <!--<span>￥{{item.price_market}}</span>-->
          </div>
          <div
            style="color: #da3632"
            v-else
          >价格登录可见</div>
        </div>

        <div class="clear"></div>
      </div>
    </div>
    <div
      v-if="navSwitch == 1 && productList.length == 0"
      class="comm-null"
    >
      <div class="con-wrap text-center">
        <!-- <img src="../../assets/null_com.png" /> -->
        <p>暂无商品</p>
      </div>
    </div>
    <div
      v-if="navSwitch == 2"
      class="board_content"
    >
      <div class="board_content1">
        <div class="board_c">
          <div
            v-for="(item, index) in classList"
            :key="index"
            :class="{ isActive: params.class_three == item.id }"
            @click="active(item.id)"
          >
            <!-- {{ item.class_name }} -->
            三棵树
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="mi">
        <p>请输入密码浏览</p>
        <input
          type="text"
          v-model="value"
        >
      </div>

      <div class="but">
        <van-button
          type="primary"
          size="large"
          @click="ok"
        >确认</van-button>
      </div>

    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { Swipe, SwipeItem, Lazyload, NoticeBar, Grid, GridItem, Popup, Button, Toast } from 'vant'

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Lazyload, { lazyComponent: true })
  .use(NoticeBar)
  .use(Grid)
  .use(GridItem).use(Popup).use(Button)

export default {
  name: 'board',
  data () {
    return {
      value: '',
      show: false,
      images: [1, 2],
      searchBarFixed: false,
      navSwitch: 1,
      number: -1,
      str: '',
      ad: [],
      classList: [],
      classList1: [],
      screenType: 'zonghe',
      productList: [],
      isEnd1: true,
      deswiper: '',
      login: sessionStorage.getItem('login'),
      isEnd: false, //判断是否为最后一页
      params: {
        page: 1,
        id: '',
        sort_field: 'sort',
        class_three: '',
        sort_type: '',
      },
      screenState: 1,
      totalHeight: 0,

      statusNav: 1,
      id: 157,
      fg:0
    }
  },
  props: {
  },
  computed: {

  },
  watch: {

  },
  created () {
    this.params.id = 156
    this.getClassList()
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  },
  mounted () {

  },
  methods: {
    gos () {
      this.$router.push("/")
    },
    go (i) {
      // Toast('正在努力备货中~')

      return false
      if (i == 1) {
        this.$router.push({
          name: 'product',
          query: {
            id: 382
          }
        })
      } else if (i == 2) {
        this.$router.push({
          name: 'product',
          query: {
            id: 388          }
        })
      } else if (i == 3) {
        this.$router.push({
          name: 'product',
          query: {
            id: 389
          }
        })
      } else if (i == 4) {
        this.$router.push({
          name: 'product',
          query: {
            id: 383
          }
        })
      }
    },
    getClientHeight () {

    },


    enterDetail (goods) {
      return false
      this.$router.push({
        name: 'product',
        params: {
          id: goods.id,
          status: 1,
        },
      })
    },
    toList (id) {
      // return false
      if (id == 1137) {
        this.show = true
this.fg=1
        return
      }
  
      this.$router.push({
        name: 'pinproduct',
        params: {
          status: 1,
        },
        query: {
          bid: id
        }
      })
    },
    ok () {
      
        if(this.fg==1){
          if (this.value == "HKJMSZ3333") {
 this.$router.push({
          name: 'pinproduct',
          params: {
            status: 1,
          },
          query: {
            bid: 1137
          }
        })
        } else {
        Toast('密码错误')
      }
        }

      if(this.fg==2){
              if (this.value == "333333") {
                this.$router.push({
          name: 'pinproduct',
          params: {
            status: 1,
          },
          query: {
            bid: 1145
          }
        })
        } else {
        Toast('密码错误')
      }
 
        }
      
    },
    active (i) {
      this.params.class_three = i
      this.navSwitch = 1
      this.productList = []
      this.params.page = 1
      this.isEnd = false
      this.getProductList()
    },
    getProductList () {

    },
    getClassList () {

    },
  },

  destroyed () { },
  updated () { },
  components: {},
}
</script>


<style lang="less" scoped>
.mi {
  padding: 0.5rem;
  text-align: center;

  p {
    font-size: 0.5rem;
    margin: 0.5rem;
  }
  input {
    height: 1rem;
    width: 70%;
    border-radius: 5%;
    font-size: 0.4rem;
  }
  margin-bottom: 1rem;
}
.sks {
  width: 100%;
  z-index: 99;
  height: 1rem;
  background-color: #fff;
  text-align: center;
  font-size: 0.4rem;
  line-height: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  //   margin-top: 0.5rem;
  // position: fixed;
  // top: 0;
  // z-index: 99;
  // width: 100%;
  span {
    width: 1rem;
    position: absolute;
    left: 0;
    font-size: 0.5rem;
  }
}
.sp {
  width: 100%;
  height: 5.4rem;
  overflow: hidden;
}
.sp::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.pad {
  height: 0.2rem;
  background-color: #cee5d5;
}
.more {
  color: #c9a48a;
  font-size: 0.7rem;
  text-align: center;
  height: 1.5rem;
  line-height: 1.5rem;
}
.fl2p {
  background-color: #f5f5f5;
  padding: 0 0.2rem;
}
.wgd {
  padding: 0 0.2rem;
  text-align: center;
  position: relative;
  height: 0.5rem;
  .qx {
    position: absolute;
    left: 0;
    width: 100%;
    top: 0.5rem;
    z-index: 20;
  }
  .gd {
    height: 0.5rem;
    background-image: linear-gradient(#fff, #cee5d5);
  }
}
.wgdb {
  background-color: #83b091;
  text-align: center;
  height: 0.9rem;
  padding-top: 0.7rem;
  position: relative;
  .sek {
    background-color: #83b091;

    position: absolute;
    top: -0.5rem;
    width: 56%;
    right: -0.2rem;
    height: 0.5rem;
  }
  .wen1 {
    width: 5.5rem;
  }
}
.cp1 {
  background-color: #83b091;
  padding: 0.2rem;
  .top {
    background-color: #83b091;

    .one {
      width: 50%;
      float: left;
      margin: 0 auto;
      background-color: #83b091;

      img {
        width: 100%;
        background-color: #83b091;
      }
    }
  }
}
.ak1 {
  width: 100%;
}
.jia {
  padding-top: 0.5rem;
  height: 1rem;
  padding-left: 2.3rem;
}
.xgd {
  height: 0.5rem;
  background-image: linear-gradient(#83b091, #fff);
}
.comm-null {
  padding-top: 0.5rem;

  p {
    font-size: 0.28rem;
    color: #666;
    padding-top: 0.2rem;
  }
}
.swiper-container {
  width: 100%;
  height: 3.28rem;
  .home-banner-img {
    width: 100%;
  }
}
.board_content {
  background: white;
  padding: 0 0.23rem;
  margin-top: 1px;
  padding-bottom: 0.15rem;

  .board_content1 {
    padding-top: 0.2rem;

    div:first-child {
      color: #333;
      font-size: 0.22rem;
      margin-bottom: 0.15rem;
    }

    .board_c {
      //    border:1px solid red;
      div {
        float: left;
        color: #333;
        font-size: 0.22rem;
        border: 1px solid #e5e5e5;
        width: 21.5%;
        margin: 0.1rem 0;
        border-radius: 0.05rem;
        text-align: center;
        height: 0.47rem;
        line-height: 0.47rem;
        margin-left: 2.55%;
      }
    }
  }
}

.isActive {
  color: #a22d2b !important;
  border: 1px solid #a22d2b !important;
}

.board {
  padding-top: 1rem;
  // 轮播
  overflow-x: hidden;
  //   padding-top: 0.8rem;
  background-color: #cee5d5;
  .mint-swipe {
    width: 100%;
    height: 3.28rem;

    .mint-swipe-items-wrap {
      width: 100%;
      height: 3.28rem;

      .mint-swipe-item {
        width: 100%;
        height: 3.28rem;

        .board-banner-img {
          width: 100%;
          height: 3.28rem;
          background-size: 100%;
        }
      }
    }
  }
  .flp {
    background-color: #cee5d5;
    padding: 0 0.2rem;
    padding-top: 0.2rem;
  }
  .fenl {
    p {
      height: 0.75rem;
      line-height: 0.5rem;
      font-weight: 700;
      font-size: 0.3rem;
    }
    background: #fff;
    padding: 0 0.3rem;
    padding-top: 0.15rem;
    text-align: center;
    box-sizing: border-box;

    .fenl_1 {
      width: 25%;
      text-align: center;
      float: left;
      margin-bottom: 0.45rem;

      img {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 5px;
        margin: 0 auto;
      }

      div {
        color: #333;
        font-size: 0.22rem;
        margin-top: 0.12rem;
      }
    }
  }

  .mt {
    margin-top: 10px;
  }

  .scrolltop {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 1000;
    margin-top: 0;
  }

  .board_imglist {
    background: #fff;
    margin-top: 1px;
    padding: 0.21rem;
    padding-top: 0.26rem;
    padding-bottom: 0.45rem;

    .board_img:nth-child(odd) {
      float: left;
      width: 48.5%;
    }

    .board_img:nth-child(even) {
      float: right;
      width: 48.5%;
    }

    .board_img {
      height: 5rem;

      .title {
        height: 0.6rem;
      }

      div:first-child {
        img {
          width: 100%;
          height: 3.2rem;
        }
      }

      div:nth-child(2) {
        margin-top: 0.16rem;

        span.sp1 {
          color: #a22d2b;
          font-size: 0.26rem;
          border: 1px solid #a22d2b;
          padding: 0.02rem 0.05rem;
          border-radius: 0.05rem;
        }

        span.sp2 {
          color: #333;
          font-size: 0.26rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          width: 100%;
        }
      }

      div:last-child {
        margin-top: 0.16rem;

        span:first-child {
          color: #a22d2b;
          font-size: 0.26rem;
        }

        /*span:last-child {*/
        /*line-height: 0.2rem;*/
        /*color: #999;*/
        /*font-size: .26rem;*/
        /*text-decoration: line-through*/
        /*}*/
      }
    }
  }
}
</style>
